<template>
  <div>
    <ElSelect
      v-model="value"
      :placeholder="
        params.filterParams.opertype === 3 ? '列表搜索' : '列表过滤'
      "
      size="mini"
      filterable
      multiple
      :reserve-keyword="false"
      clearable
      :filter-method="filterMethod"
      :popper-class="
        isHeader
          ? 'ag-table-float-el-select-popper show-headers'
          : 'ag-table-float-el-select-popper show-header'
      "
      @focus="filterMethod('')"
      @change="handleChange"
      class="ag-table-float-el-select"
    >
      <div class="ag-table-float-el-select-header">
        <el-checkbox
          v-model="checkAll"
          :indeterminate="indeterminate"
          @change="handleCheckAll"
        >
          全选
        </el-checkbox>
        <el-checkbox
          v-if="isHeader"
          v-model="showDisabled"
          @change="handleCheckBoxChange"
          >显示禁用</el-checkbox
        >
      </div>
      <!-- <template #header>
      <div class="un-flex un-items-center un-justify-between">
        <el-checkbox
          v-model="checkAll"
          :indeterminate="indeterminate"
          @change="handleCheckAll"
        >
          全选
        </el-checkbox>
        <el-checkbox
          v-if="isHeader"
          v-model="showDisabled"
          @change="handleCheckBoxChange"
          >显示禁用</el-checkbox
        >
      </div>
    </template> -->
      <!-- <template #tag>
      <div class="value-wrap">{{ value.join(",") }}</div>
    </template> -->
      <el-option
        :key="index"
        :label="item.name"
        :value="item.name"
        v-for="(item, index) in filterList"
      >
        <span
          v-if="parseInt(item.ison) === 0"
          style="text-decoration: line-through; font-style: italic"
          >{{ item.name }}</span
        >
        <span v-else>{{ item.name }}</span>
      </el-option>
    </ElSelect>
  </div>
</template>
<script>
import ElSelect from './select/src/select.vue'
export default {
  components: { ElSelect },
  data () {
    return {
      value: [],
      checkAll: false,
      showDisabled: false,
      indeterminate: false,
      filterList: []
    }
  },
  computed: {
    options () {
      return this.params.filterParams.list || []
    },
    ableOptions () {
      return this.options.filter(item => parseInt(item.ison) === 1)
    },
    isHeader () {
      return (
        this.ableOptions.length && this.ableOptions.length < this.options.length
      )
    },
    currentOptions () {
      return this.isHeader
        ? this.showDisabled
          ? this.options
          : this.ableOptions
        : this.options
    }
  },
  watch: {
    value (val) {
      if (val.length === 0) {
        this.checkAll = false
        this.indeterminate = false
      } else if (val.length === this.currentOptions.length) {
        this.checkAll = true
        this.indeterminate = false
      } else {
        this.indeterminate = true
      }
    }
  },
  methods: {
    filterMethod (value) {
      this.filterList = this.currentOptions.filter(item => {
        return item.name.toLowerCase().includes(value.toLowerCase())
      })
    },
    handleCheckBoxChange () {
      if (this.value && this.value.length) {
        this.value = []
        this.handleChange()
      }
    },
    handleCheckAll (val) {
      this.indeterminate = false
      if (val) {
        this.value = this.filterList.map(item => item.name)
      } else {
        this.value = []
      }
      this.handleChange()
    },
    handleChange () {
      if (this.value && this.value.length) {
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', this.value.join(','))
        })
      } else {
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', null)
        })
      }
      if (this.params.filterParams.opertype === 3) {
        this.params.enter()
      }
    },
    onParentModelChanged (parentModel, event) {
      // When the filter is empty we will receive a null value here
      if (!parentModel) {
        this.value = []
      } else {
        this.value = parentModel.filter.split(',') || []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.ag-table-float-el-select {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 1px);

  .el-input__inner {
    height: 29px;
    border-radius: 0;
    border-color: transparent;
    padding: 1px 7px !important;
    &:focus {
      border-color: #32b16c;
    }
  }
  .el-input__suffix {
    .el-icon-arrow-up {
      display: none;
    }
    // display: none;
  }
  .el-select__input {
    margin-left: 7px !important;
  }
}
</style>
